import gql from 'graphql-tag';

import { fileFragmentQuery, shortFileFragmentQuery } from '~/shared/graphql-queries/files/file-fragment';

export const shortCourseFragmentQuery = `
  fragment ShortCourseFragment on Course {
    _id
    title
    alias
    language
    courseType
    isPublished
    isTrialLessons
    price
    currency
    isFreeCourse
    
    image {
      ...ShortFileFragment
    }
    thumbnail {
      ...ShortFileFragment
    }
  }
  ${shortFileFragmentQuery}
`;

export const courseBaseFragmentQuery = `
  fragment CourseBaseFragment on Course {
    _id
    title
    description
    isPublished
    voteRate
    courseDirection
    language
    isFreeCourse
    isTrialLessons
    price
    currency
    totalModules
    courseType
    countOfVotes
    metaKeyWords
    metaDescription
    metaTitle
    alias
    content
    createdAt
    updatedAt
    creator {
      _id
      login
      firstName
      lastName
      avatar {
      path
      }
    }
    company {
      _id
      courseDirections {
      courseDirectionName
      _id
      }
    }
  }
`;

export const courseSettingsFragmentQuery = `
  fragment CourseSettingsFragment on Course {
    settings {
      isFilesOpenedInModal
      isSelectionOfAnyLesson
      isGoNextAfterCompletionFile
      isExerciseSurvey
      brandColor
      isProgressBar
      isFilesListOpenedInLesson
      eventColor
      isBlockBreadcrumbsNavigationInLesson
      trialLessonDurationMinutes
      firstLessonDurationMinutes
      isSurveyFunctionalityEnabled
      isMetricsFunctionalityEnabled
      isEnableSurveyByDefault
      isEnableAutomaticTransitionToExerciseFile
      isEventsWithoutLessons
      isAutoSelectionOfFilesWhenDragging
      isStudentAbilityToRecordLesson
      isStudentAbilityToExpandCollapseVideoStream
      isAutoShowingOfNextFileExercise
      isAbilityToAddHomeTask
      isHiddenCameraWhenSharingScreen
      isHiddenLessonIsNotCompleteButton
      isHiddenSlidesRibbonInPresentation
      isDisabledCompleteLessonInfoForStudent
      isStudentAbilityToDrawDuringTheLesson
      isHideShowingOfExercisesInLessonCardsForStudent
      isEditableModuleForTeacher
      isToDoExercises
      isTrialLessonToDoExercises
    }
  }
`;

export const courseFragmentQuery = `
  fragment CourseFragment on Course {
    ...CourseBaseFragment
    ...CourseSettingsFragment
    videos {
      ...FileFragment
    }
    files {
      ...FileFragment
    }
    image {
      ...FileFragment
    }
    thumbnail {
      ...FileFragment
    }
  }
  ${courseBaseFragmentQuery}
  ${courseSettingsFragmentQuery}
  ${fileFragmentQuery}
`;

export const shortCourseFragment = gql`
    ${shortCourseFragmentQuery}
`;

const courseFragment = gql`
    ${courseFragmentQuery}
`;

export default courseFragment;
